import { render, staticRenderFns } from "./FixTemplateRedirectPage.vue?vue&type=template&id=0e016a1a&"
import script from "./FixTemplateRedirectPage.vue?vue&type=script&lang=js&"
export * from "./FixTemplateRedirectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports